import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@/lib/auth-context";

const options = [
  { v: "", label: "No preview" },
  { v: "sponsor", label: "Preview: Sponsor" },
  { v: "teacher", label: "Preview: Teacher" },
  { v: "admin", label: "Preview: Admin" },
];

export default function AdminBar() {
  const { user, role, setPreviewRole, previewRole, isSuperAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(false);
  }, [isSuperAdmin]);
  const show = !!user && isSuperAdmin;
  const emails = useMemo(() => (user?.email ? user.email : ""), [user]);
  if (!show) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50">
      <div className="mx-auto max-w-6xl px-3">
        <div className="mt-2 rounded-xl shadow-md bg-cocoa text-white px-3 py-2 flex items-center justify-between">
          <div className="text-sm">
            Superadmin: <span className="font-semibold">{emails}</span>
            <span className="ml-2 opacity-80">real role: {role || "unknown"}</span>
          </div>
          <div className="flex items-center gap-2">
            <label className="text-sm opacity-90" htmlFor="preview-role-select">
              Preview as:
            </label>
            <select
              id="preview-role-select"
              className="text-cocoa rounded-md px-2 py-1"
              value={previewRole || ""}
              onChange={event => setPreviewRole(event.target.value || null)}
            >
              {options.map(option => (
                <option key={option.v} value={option.v}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
